import { render } from "./chat-content.vue?vue&type=template&id=7d830e98"
import script from "./chat-content.vue?vue&type=script&lang=js"
export * from "./chat-content.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__